export default __webpack_public_path__ + "static/media/Pin_Job_TireInstall.74ca70b8.svg";